import creator from '@utils/creator.js';
import 'vite/modulepreload-polyfill';

import lazySizes from 'lazysizes';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';
import 'lazysizes/plugins/attrchange/ls.attrchange';
import 'lazysizes/plugins/respimg/ls.respimg';
import 'lazysizes/plugins/native-loading/ls.native-loading';

import {revive} from '@script/lib/revive.js';
import {initCMPShopifyBridge} from '@script/lib/cmp-shopify-bridge.js';

import {
	HeartWishlist,
	ListingWishlist,
	ShareWishlist,
} from '@colorz-packages/sendwish-front';

import TextExpand from '@components/TextExpand';
import ExpandableMobile from '../colorz/core/ExpandableMobile';

import SliderNoDefer from '@components/ClrzSliderNoDefer';
import Expandable from '@components/Expandable';

import CardProduct from '@components/CardProduct';
import Newsletter from '@components/Newsletter';
import AnnouncementBar from '@components/AnnouncementBar';
import Timeline from '@components/Timeline';
import Anchor from '../colorz/core/Anchor';
import '../lib/iovation-loader-5.x.js';

import FaqItem from '@components/FaqItem';

import BookmarkButton from '@components/BookmarkButton';
import WishlistHeartFocus from '@components/WishlistHeartFocus';
import TruncateHtml from '@components/TruncateHtml';

import TabIndexMobile from '@components/TabIndexMobile.js';
import SubscriptionFormPlus from '@components/SubscriptionFormPlus';
import FormRegister from '@components/FormRegister.js';

import ValidationForm from '@components/ValidationForm.js';
import DeliveryNotice from '@components/DeliveryNotice';

import AnnouncementTimer from '@components/Timer.js';
import StoreLocator from '@components/StoreLocator.js';
import CartBenefitsGauge from '@components/CartBenefitsGauge.js';
import LoyaltyLionStatus from '@components/LoyaltyLionStatus.js';
import SubmitCartForm from '@components/SubmitCartForm.js';

lazySizes.cfg.lazyClass = 'lazyload';
lazySizes.cfg.init = true;
lazySizes.cfg.preloadAfterLoad = false;
lazySizes.cfg.loadMode = 1;
lazySizes.cfg.nativeLoading = {
	setLoadingAttribute: true,
	disableListeners: {
		focus: false,
		mouseover: false,
		click: false,
		load: false,
		transitionend: false,
		animationend: false,
		scroll: true,
		resize: true,
	},
};

import {initKeyboardFocusScrollIntoView} from '@utils/ally/keyboardFocusScrollIntoView.js';

import Header from '@components/Header';
import Tabs from '@components/Tabs';
import HistoricalsProduct from '@components/HistoricalsProducts';
import LastReviewsYotpo from '@components/LastReviewsYotpo';
import WorldHQs from '@components/WorldHQs';

window.ClrzApp = {};

function ClrzAppInit() {
	ClrzApp.Header = creator('.js-header', Header);
	ClrzApp.TextExpand = creator('.js-text-expand', TextExpand);
	ClrzApp.ExpandableMobile = creator('.js-expandable-mobile', ExpandableMobile);
	customElements.define('clrz-slider-no-defer', SliderNoDefer);
	ClrzApp.Expandable = creator('.js-expandable', Expandable);
	customElements.define('card-product', CardProduct);
	ClrzApp.Newsletter = creator('.js-newsletter', Newsletter);
	ClrzApp.AnnouncementBar = creator('.js-announcement-bar', AnnouncementBar);
	ClrzApp.Tabs = creator('.js-tabs', Tabs);
	ClrzApp.Timeline = creator('.js-timeline', Timeline);
	ClrzApp.Anchor = creator('.js-anchor', Anchor);
	ClrzApp.BookmarkButton = creator('.js-bookmark-button', BookmarkButton);
	ClrzApp.WishlistHeartFocus = creator('heart-wishlist', WishlistHeartFocus);
	ClrzApp.FaqItem = creator('.js-faq', FaqItem);

	ClrzApp.TruncateHtml = creator('.js-truncate-html', TruncateHtml);
	ClrzApp.TabIndexMobile = creator('.js-tab-index-mobile', TabIndexMobile);
	customElements.define('subscription-form-plus', SubscriptionFormPlus);
	ClrzApp.FormRegister = creator('.js-form-register', FormRegister);

	ClrzApp.ValidationForm = creator('.js-validation-form', ValidationForm);
	customElements.define('delivery-notice', DeliveryNotice);

	ClrzApp.HistoricalsProduct = creator(
		'.js-historical-products',
		HistoricalsProduct,
	);
	ClrzApp.SubmitCartForm = creator('.js-submit-cart-form', SubmitCartForm);
	ClrzApp.AnnouncementTimer = creator(
		'.js-announcement-timer',
		AnnouncementTimer,
	);

	customElements.define('store-locator', StoreLocator);
	customElements.define('cart-benefits-gauge', CartBenefitsGauge);
	customElements.define('loyaltylion-status', LoyaltyLionStatus);
	ClrzApp.LastReviewsYotpo = creator(
		'.js-last-reviews-yotpo',
		LastReviewsYotpo,
	);

	ClrzApp.WorldHQs = creator('.js-world-hqs', WorldHQs);
}

ClrzAppInit();
initKeyboardFocusScrollIntoView();
initCMPShopifyBridge();

export const islands = import.meta.glob('../islands/*.js');

for (let island in islands) {
	revive(island, islands);
}

document.addEventListener('product-recommendations-render', function () {
	ClrzApp.CardProduct = creator('.js-card-product', CardProduct);
	creator('heart-wishlist', WishlistHeartFocus);
});

document.addEventListener('update-cart-render', function (e) {
	ClrzApp.Expandable = creator('.js-expandable', Expandable);
	customElements.define('clrz-slider-no-defer', SliderNoDefer);

	const {isOpen, id} = e.detail;
	if (isOpen) {
		ClrzApp.Expandable.forEach((expandable) => {
			if (expandable.el.id == id) {
				expandable.open();
			}
		});
	}
});
